import {ReactNode} from "react";
import XMark from "../icons/xmark";

export interface ModalProps {
    title: string;
    visible: boolean;
    onClose: (save: boolean) => void;
    children: ReactNode;
}

export default (props: ModalProps) => (
    <div className={`modal ${props.visible ? "block" : "hidden"}`}>
        <div className="container">
            <div className="modal-close">
                <XMark onClick={() => props.onClose(false)}/>
            </div>

            <div className="modal-content">
                <div className="modal-header">
                    <h2>{props.title}</h2>
                </div>
                <div className="modal-body">
                    {props.children}
                </div>
            </div>
        </div>
    </div>
)